import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import * as Styled from './SquarespaceDomainsCard.styles';

const SquarespaceDomainsCard = () => {
  const { formatMessage: fm } = useIntl();
  const dashboardPath = useDashboardPath();

  const destination = `${dashboardPath}/marketing-tools/domains`;

  return (
    <Styled.Root>
      <Styled.Image
        alt={fm({ id: 'dashboard.carousel.card.squarespaceDomains.imageAlt' })}
        src="/s2/raster/woman-on-ipad.png"
      />
      <Styled.CardContent>
        <ContentHeader
          title={<Text size="md" weight="medium" color="primary"><FormattedMessage id="dashboard.carousel.card.squarespaceDomains.title" /></Text>}
          subtitle={<Text size="sm" weight="regular" color="secondary"><FormattedMessage id="dashboard.carousel.card.squarespaceDomains.subTitle" /></Text>}
        >
          <Styled.CardButton
            clickstreamProps={{
              elementName: 'carousel_link',
              elementText: 'squarespace_domains',
              destination
            }}
            color="secondary"
            size="sm"
            to={destination}
            endIcon={<ArrowForwardIcon />}
          >
            <FormattedMessage id="dashboard.carousel.card.squarespaceDomains.button" />
          </Styled.CardButton>
        </ContentHeader>
        <Styled.CardFooter>
          <Text size="xs" weight="regular" color="tertiary">
            <FormattedMessage id="dashboard.carousel.card.squarespaceDomains.footer" />
          </Text>
          <Styled.Logo
            alt={fm({ id: 'dashboard.carousel.card.squarespaceDomains.footerLogoAlt' })}
            src="/s2/vector/squarespace-logo.svg"
          />
        </Styled.CardFooter>
      </Styled.CardContent>
    </Styled.Root>
  );
};

export default SquarespaceDomainsCard;
